import { inject, Injectable, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { catchError, EMPTY, filter, map, Observable, switchMap, take, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { UserStore } from './stores/user.store';
import { UsersService } from './api/users.api.service';
import { RoutesName } from '../shared/constants/routes-name';


@Injectable({ providedIn: 'root' })
export class AccessControlService {
  private readonly injector = inject(Injector);
  private readonly userStore = inject(UserStore);
  private readonly usersService = inject(UsersService);
  private readonly router = inject(Router);

  ensureAllowed(): Observable<boolean> {
    return toObservable(this.userStore.userIdSignal, { injector: this.injector }).pipe(
      filter((id): id is string => !!id),
      take(1),
      switchMap((id) =>
        this.usersService.getById(id).pipe(
          map(() => true),
          catchError((err) => {
            if (err?.status === 404) {
              this.router.navigate([RoutesName.FORBIDDEN]);
              return EMPTY;
            }
            return throwError(() => err);
          })
        )
      )
    );
  }
}
